//** Import Components */
import {
  Table,
  Tooltip,
  Empty,
  Space,
  Tag,
  Collapse,
  Grid,
  Button,
  Pagination,
} from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { TABLE_DATE_FORMAT } from "../common/constants";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import JitsiMeetUser from "../routes/BusinessDashboard/pages/JitsiMeet/JitsiMeetUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export const useManagementAppointmentsUser = () => {
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { Panel } = Collapse;

  const dateFormat = TABLE_DATE_FORMAT;

  const columns = [
    {
      title: "Service Name",
      key: "ad_name",
      render: (text) => <>{text.service.name}</>,
    },
    {
      title: "Business Name",
      key: "ad_name",
      render: (text) => <>{text.service.business[0].name}</>,
    },
    {
      title: "Date",
      key: "appointment_date",
      render: (text) => (
        <>{moment(new Date(text && text.start_time)).format(dateFormat)}</>
      ),
    },
    {
      title: "Start Time",
      key: "appointment_hour",
      render: (text) => <>{moment.utc(text.start_time).format("hh:mm A")}</>,
    },
    {
      title: "Duration",
      key: "duration",
      render: (text) => (
        <>
          {text.service.meta_data.find(
            (meta) => meta.meta_key === "service_duration_time"
          ).meta_value + " HOURS"}
        </>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (text) => (
        <>
          {text.status === "cancelled" && (
            <Tag icon={<ExclamationCircleOutlined />} color="error">
              {text && text.status}
            </Tag>
          )}
          {text.status === "postponed" && (
            <Tag icon={<ClockCircleOutlined />} color="warning">
              {text && text.status}
            </Tag>
          )}
          {text.status === "pending" && (
            <Tag icon={<SyncOutlined spin />} color="processing">
              {text && text.status}
            </Tag>
          )}
          {text.status === "confirmed" && (
            <Tag icon={<CheckCircleOutlined />} color="success">
              {text && text.status}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Date Created",
      key: "created",
      render: (text) => (
        <>{moment(new Date(text && text.created)).format(dateFormat)}</>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text) => (
        <>
          <Space size="middle">
            {text.status === "pending" && (
              <button
                onClick={() => {
                  navigate(`${text.id}`);
                }}
              >
                <Tooltip title="Edit">
                  <FontAwesomeIcon icon={faEdit} />
                </Tooltip>
              </button>
            )}
            <JitsiMeetUser product={text} type="appointment" />
          </Space>
        </>
      ),
    },
  ];

  const CardListComponent = ({ listItems }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const start = (currentPage - 1) * pageSize;
    const currentItems = listItems.slice(start, start + pageSize);

    return (
      <>
        <Collapse accordion>
          {currentItems.map((item) => (
            <Panel
              key={item.id}
              header={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <strong>{item.service.name}</strong> -{" "}
                    {moment(new Date(item && item.start_time)).format(
                      dateFormat
                    )}
                  </span>
                  {item.status === "cancelled" && (
                    <Tag color="error">
                      <ExclamationCircleOutlined />
                    </Tag>
                  )}
                  {item.status === "postponed" && (
                    <Tag color="warning">
                      <ClockCircleOutlined />
                    </Tag>
                  )}
                  {item.status === "pending" && (
                    <Tag color="processing">
                      <SyncOutlined spin />
                    </Tag>
                  )}
                  {item.status === "confirmed" && (
                    <Tag color="success">
                      <CheckCircleOutlined />
                    </Tag>
                  )}
                </div>
              }
            >
              <p>
                <strong>Service name:</strong> {item.service.name}
              </p>
              <p>
                <strong>Business Name:</strong> {item.service.business[0].name}
              </p>
              <p>
                <strong>Date:</strong>{" "}
                {moment(new Date(item && item.start_time)).format(dateFormat)}
              </p>
              <p>
                <strong>Start time:</strong>{" "}
                {moment.utc(item.start_time).format("hh:mm A")}
              </p>
              <p>
                <strong>Duration:</strong>{" "}
                {item.service.meta_data.find(
                  (meta) => meta.meta_key === "service_duration_time"
                ).meta_value + " HOURS"}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {item.status === "cancelled" && (
                  <Tag icon={<ExclamationCircleOutlined />} color="error">
                    {item && item.status}
                  </Tag>
                )}
                {item.status === "postponed" && (
                  <Tag icon={<ClockCircleOutlined />} color="warning">
                    {item && item.status}
                  </Tag>
                )}
                {item.status === "pending" && (
                  <Tag icon={<SyncOutlined spin />} color="processing">
                    {item && item.status}
                  </Tag>
                )}
                {item.status === "confirmed" && (
                  <Tag icon={<CheckCircleOutlined />} color="success">
                    {item && item.status}
                  </Tag>
                )}
              </p>
              <p>
                <strong>Date Created:</strong>{" "}
                {moment(new Date(item && item.created)).format(dateFormat)}
              </p>
              <Space size="middle">
                {item.status === "pending" && (
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate(`${item.id}`);
                    }}
                  >
                    <Tooltip title="Edit">
                      <FontAwesomeIcon icon={faEdit} />
                    </Tooltip>
                  </Button>
                )}
                <JitsiMeetUser product={item} type="appointment" />
              </Space>
            </Panel>
          ))}
        </Collapse>

        <div style={{ marginTop: 16, textAlign: "center" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={listItems.length}
            onChange={(page) => setCurrentPage(page)}
            size="small"
          />
        </div>
      </>
    );
  };

  const ListComponent = ({ emptyMessage, listItems }) => {
    if (listItems.length === 0) {
      return (
        <Empty
          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          imageStyle={{ height: 60 }}
          description={<span>{emptyMessage}</span>}
        />
      );
    }

    return screens.md ? (
      <Table columns={columns} dataSource={listItems} scroll={{ x: 1000 }} />
    ) : (
      <CardListComponent listItems={listItems} />
    );
  };

  return [ListComponent];
};
